module.exports = __webpack_public_path__ + "static/media/what-we-offer.22ff1bbc.png";